import { render, staticRenderFns } from "./UpdateUser.vue?vue&type=template&id=db99d010&scoped=true&"
import script from "./UpdateUser.vue?vue&type=script&lang=ts&"
export * from "./UpdateUser.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUser.vue?vue&type=style&index=0&id=db99d010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db99d010",
  null
  
)

export default component.exports